module.exports = __webpack_public_path__ + "img/4-01-04-charge.c162eba3.svg";